import { createFileRoute } from "@tanstack/react-router";
import { JobPage } from "@/features/queues/job-page";

export const Route = createFileRoute("/_authenticated/queues/$queue/jobs/$jobId")({
  head: () => ({ meta: [{ title: "Job · Rogue Admin" }] }),
  component: JobPage,
});
